import React, { FC } from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const VidoeList = lazyLoader(
  () => import("Containers/Training/TrainingVideoList/TrainingVideoList")
);

export const TrainingVideoListPage: FC = () => {
  return (
    <Layout>
      <VidoeList />
    </Layout>
  );
};
